import { Button, Theme, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import styles from './NewbuildingTourLayout.css';

interface INewbuildingTourLayoutProps {
  tourBannerImageUrl: string;
  onClick: () => void;
}

export const NewbuildingTourLayout: React.FC<INewbuildingTourLayoutProps> = ({ tourBannerImageUrl, onClick }) => {
  return (
    <div
      className={styles['layout']}
      style={{ backgroundImage: `url(${tourBannerImageUrl})` }}
      data-tour="layout"
      data-testid="tour"
      onClick={onClick}
    >
      <div className={styles['text']}>
        <div className={styles['icon']} />
        <UIHeading2 userSelect="none" color="text-inverted-default">
          Посмотрите 3D-тур, чтобы оценить объект
        </UIHeading2>
      </div>
      <Theme theme="colored">
        <Button theme="fill_primary" size="M">
          Посмотреть
        </Button>
      </Theme>
    </div>
  );
};
